export default __webpack_public_path__ + "static/media/css3-logo.ae840d35.png";